// English dictionary for the landing bundle. Same key shape as uk.js.

export const dict = {
  brand: {
    eyebrow: "AI Bot · for medical clinics",
    name: "AI Bot",
  },

  hero: {
    titleAccent: "AI receptionist",
    titleRest: "for medical clinics",
    lede:
      "Front desk drowning in calls? The AI bot answers patients 24/7 on Telegram, Instagram and your website, and hands off complex requests to an admin with the full conversation context.",
    ctaTry: "Try for free",
    ctaLogin: "Sign in",
    metric247Label: "patient replies",
    metricLoadValue: "−60%",
    metricLoadLabel: "front-desk load",
    metricChannelsValue: "5 channels",
    metricChannelsLabel: "in a single inbox",
  },

  heroChat: {
    channelTitle: "Telegram · Healthcare+ Clinic",
    live: "● LIVE",
    rolePatient: "You",
    roleAi: "AI Bot",
    roleOperator: "Maria · admin",
    nodePatient: "Patient",
    nodePatientName: "Olena K.",
    nodeAi: "AI Bot",
    nodeAiRole: "First line",
    nodeOperator: "Administrator",
    nodeOperatorName: "Maria S.",
    msg1: "Hi! Is the cardiologist seeing patients today?",
    msg2: "Hello! Today Dr. O. Koval is seeing patients, 14:00–18:00. Consultation — UAH 950.",
    msg3: "Can I book with \"VUSO\" insurance?",
    msg4: "I'm handing you off to an administrator — they'll confirm coverage for your policy.",
    msg5: "Hello, Olena! I can see your request. Yes, we work with \"VUSO\".",
  },

  safety: {
    strong: "AI does not make diagnoses or prescribe treatment.",
    text: "The assistant answers informational questions and routes medical ones to a doctor. Every interaction is supervised by the clinic.",
  },

  benefits: {
    eyebrow: "Benefits",
    titleAccent: "Fewer calls.",
    titleMuted: "More attention for patients.",
    items: [
      { title: "Works 24/7", body: "Patients get answers at night, on weekends and holidays — without delays." },
      { title: "All channels in one inbox", body: "Website, Telegram, Facebook, Instagram and HelpCrunch — a single window for admins." },
      { title: "Smooth handoff to an operator", body: "When AI is not confident, the conversation moves to a human with full context." },
      { title: "Clinica Web integration", body: "Prices, doctors, services, schedule — live data straight from your EHR." },
      { title: "Semantic knowledge base", body: "Articles, FAQ, branches, insurance partners — AI learns from your data." },
      { title: "Safe medical communication", body: "No diagnoses, no treatment advice. Personal data — under control." },
    ],
  },

  how: {
    eyebrow: "How it works",
    titleAccent: "AI is the first line.",
    titleMuted: "Humans are there when needed.",
    steps: [
      { title: "Patient writes in any channel", body: "Site messenger, Telegram bot, Facebook, Instagram Direct. One message — one system." },
      { title: "AI Bot replies in seconds", body: "The assistant uses your Clinica Web data and knowledge base: services, prices, doctors, schedule, branches, articles." },
      { title: "Complex request — handoff to an operator", body: "If the question goes out of scope — or the patient asks for a human — an admin gets the conversation with full context." },
      { title: "EHR synchronization", body: "Clarifying appointments, insurance policies, results — together with your medical information system." },
    ],
    visual: {
      channelsTitle: "Omnichannel inbox",
      aiTitle: "AI knows your clinic",
      handoffTitle: "Handoff with full context",
      syncTitle: "Direct link with Clinica Web",
      aiQueryLabel: "Query:",
      aiQuery: "\"How much is a thyroid ultrasound and who sees patients?\"",
      aiSrc1: "Clinica Web price list · \"Thyroid ultrasound — UAH 650\"",
      aiSrc2: "Schedule · \"Dr. L. Kravchuk, Tue/Thu, 9:00–13:00\"",
      aiSrc3: "Article \"Preparing for an ultrasound\" · knowledge base",
      aiAnswer1: "A thyroid ultrasound costs",
      aiAnswer2: ". Dr. L. Kravchuk sees patients on Tue and Thu, 9:00–13:00. No preparation needed.",
      inboxRows: [
        { name: "Olena K.", preview: "Is the cardiologist seeing patients today?", t: "14:02" },
        { name: "Andriy B.", preview: "How much is a thyroid ultrasound?", t: "13:48" },
        { name: "Site guest", preview: "Is there a branch in Obolon?", t: "13:30" },
        { name: "Natalia R.", preview: "How do I prepare for a blood test?", t: "12:55" },
      ],
      handoffName: "Olena K.",
      handoffDialog: "Telegram · conversation #2481",
      handoffTag: "Handed off",
      handoffSummary: "Summary by AI",
      handoffPoints: [
        "Question about cardiologist visit",
        "Interested in \"VUSO\" insurance",
        "Recommended to confirm coverage",
      ],
      handoffAssigned: "Assigned:",
      handoffAssignee: "Maria S.",
      handoffTime: "22 sec ago",
      syncAiName: "AI Bot",
      syncAiRole: "Assistant",
      syncCwName: "Clinica Web",
      syncCwRole: "EHR",
      syncRow1: "Services, prices",
      syncRow2: "Doctors, schedule",
      syncRow3: "Real-time updates",
      syncRow4: "Branches, insurance",
    },
  },

  features: {
    eyebrow: "Capabilities",
    titleAccent: "Everything a clinic needs",
    titleMuted: "for modern communication.",
    f1: {
      tag: "Live chat",
      title: "A single inbox for administrators",
      body: "All conversations from every channel — in one panel. Conversation history, quick replies, templates, operator transfers, notes and tags. Runs in a browser — no install required.",
      list: [
        "Add an operator to any conversation",
        "Quick replies and templates for typical questions",
        "Tags, notes, priorities — to match your processes",
      ],
    },
    f2: {
      tag: "Trained on your data",
      title: "AI replies like your administrator",
      body: "Connect Clinica Web, upload articles and FAQs — AI will automatically build a knowledge base. Vector search is used, so the assistant cites sources and doesn't make up facts.",
      list: [
        "Automatic data updates from the EHR",
        "Transparency: you see which source the answer is from",
        "Tone of voice and glossary are configurable",
      ],
    },
    f3: {
      tag: "Admin panel",
      title: "Manage content and rules — no developers needed",
      body: "Edit replies, add branches, change escalation rules, connect new channels. Multi-tenant architecture — a network of clinics works from a single panel with role separation.",
      list: [
        "Roles: owner, manager, administrator, operator",
        "Analytics: conversations, SLA, topics, sources",
        "Audit log of all changes",
      ],
    },
    inboxMock: {
      title: "Inbox · AI Bot",
      sideHeader: "Conversations",
      lastSeen: "last: 2 min ago",
      headerSub: "Telegram · cardiology",
      tag1: "booking",
      tag2: "insurance",
      msg1: "Is the cardiologist seeing patients today?",
      msg2: "Yes, Dr. O. Koval, 14:00–18:00. Shall I book you in?",
      msg3: "Yes, and with \"VUSO\" insurance",
      sysHandoff: "AI handed the conversation to administrator Maria",
      msg4: "Hello! We work with \"VUSO\", we'll process it now.",
      names: ["Olena K.", "Andriy B.", "Natalia R.", "Guest #4412", "Iryna O."],
    },
    kbMock: {
      title: "Knowledge base",
      head: "AI sources",
      sub: "5 active · knowledge indexing enabled",
      add: "Add",
      sources: [
        { type: "EHR", title: "Service price list · 284 items", updated: "updated hourly" },
        { type: "EHR", title: "Doctors schedule · 42 doctors", updated: "updated hourly" },
        { type: "Article", title: "Preparing for tests", updated: "v3 · 12 days ago" },
        { type: "FAQ", title: "Insurance partners", updated: "v5 · 3 days ago" },
        { type: "Data", title: "Branches · addresses, hours", updated: "manual" },
      ],
    },
    adminMock: {
      title: "Settings · Healthcare+ Clinic",
      stat1: "Conversations per week",
      stat2: "Percent of AI replies",
      stat3: "Average response time",
      stat3Value: "2.4 s",
      section: "Channels",
      connected: "Connected",
      channels: [
        { name: "Website widget" },
        { name: "Telegram · @zdoroviaplus_bot" },
        { name: "Facebook Messenger" },
        { name: "Instagram Direct" },
      ],
    },
  },

  integrations: {
    eyebrow: "Integrations",
    titleAccent: "Works with what",
    titleMuted: "you already have.",
    primaryBadge: "Primary",
    note1: "Need another EHR or channel?",
    noteLink: "Write to us",
    note2: "— we'll evaluate an integration individually.",
    items: [
      { name: "Clinica Web", desc: "Medical information system" },
      { name: "Telegram", desc: "Bot and direct messages" },
      { name: "Facebook", desc: "Clinic page Messenger" },
      { name: "Instagram", desc: "Direct messages" },
      { name: "Website widget", desc: "Live chat on your site" },
      { name: "HelpCrunch", desc: "Connect existing chats" },
    ],
  },

  cases: {
    eyebrow: "Cases",
    titleAccent: "Results of medical clinics,",
    titleMuted: "centers and labs.",
    sub: "More than 50 medical facilities have already automated patient communication",
    photoLabel: "photo",
    items: [
      {
        tag: "Clinic network",
        title: "Healthcare+ network",
        body: "6 branches, 80+ doctors. AI answers questions about services, prices and schedule across all branches. The front desk only gets targeted calls.",
        metric: "−54% time spent processing messages",
      },
      {
        tag: "Diagnostic center",
        title: "MedTest laboratory",
        body: "Patients ask about test prep and turnaround times. AI answers 80% of requests, lab staff step in only when a human is needed.",
        metric: "80% automated replies",
      },
      {
        tag: "Specialized center",
        title: "Lira reproduction center",
        body: "Sensitive topic — tact matters. AI gives general info, and delicate questions are immediately handed off to a coordinator with an empathetic prompt.",
        metric: "24/7 patient support",
      },
    ],
  },

  faq: {
    eyebrow: "Frequently asked questions",
    titleAccent: "Answers to what",
    titleMuted: "people usually ask.",
    items: [
      { q: "Does AI make diagnoses?", a: "No. AI only answers informational questions: about services, prices, doctors, schedule, preparing for procedures. Medical questions are automatically routed to a doctor or administrator." },
      { q: "How does Clinica Web integration work?", a: "Through the official API. We sync services, prices, doctors, schedule and branches. Data updates online, AI always has up-to-date information. Onboarding takes 3–5 days." },
      { q: "Is patient personal data safe?", a: "Yes. The service meets GDPR and Ukrainian data protection requirements. Data is stored in the EU, encrypted, and access is granted by role. Deployment on your own infrastructure is also possible." },
      { q: "What if AI doesn't know the answer?", a: "The assistant honestly says it's not sure and immediately hands the conversation to an administrator. The patient is not left alone, the conversation context is preserved, and the human sees the whole history." },
      { q: "How long does onboarding take?", a: "For a single clinic with a standard set of channels — 5–7 business days. A network with EHR integration — 2–3 weeks. Staff training is included." },
      { q: "Can AI be trained on our own materials?", a: "Yes. Upload articles, FAQs, internal guidelines and AI will use them as sources. Tone of voice, glossary and escalation rules are fully under your control." },
      { q: "Is AI Bot suitable for a dental clinic?", a: "Yes. AI Bot adapts to any type of medical facility, from dentistry and labs to specialized centers. You configure the knowledge base for your clinic's profile yourself." },
      { q: "Can it be connected without Clinica Web?", a: "Yes. You can upload prices, schedule and FAQ manually or via files. Clinica Web is the recommended integration for automatic data updates." },
      { q: "How much does AI Bot cost for a clinic?", a: "The first 14 days are free. After that, pricing depends on the number of channels and conversation volume. Contact our manager for details." },
      { q: "Is it suitable for a network of multiple branches?", a: "Yes. The bot's architecture lets you manage all branches from a single admin panel with role-based access." },
    ],
  },

  cta: {
    eyebrow: "Start in 5 minutes",
    title1: "Automate your clinic's",
    title2: "front desk today",
    sub: "Join 50+ clinics that have already cut down request handling time.",
    list: [
      "Google Workspace and Microsoft 365 support",
      "Clinica Web connection wizard",
      "Free 14-day trial period",
      "Help at every setup step",
    ],
    btnTry: "Try for free",
    btnDemo: "Request a demo",
    deviceTitle: "AI Bot",
    deviceSub: "Register your medical facility",
    deviceCap: "Choose how to sign in",
    google: "Continue with Google",
    microsoft: "Continue with Microsoft",
  },

  nav: {
    benefits: "Benefits",
    how: "How it works",
    features: "Features",
    integrations: "Integrations",
    cases: "Cases",
    faq: "FAQ",
    login: "Sign in",
    createAccount: "Create account",
    languageLabel: "Language",
  },

  footer: {
    tagline: "AI communication platform for medical clinics, diagnostic centers and labs.",
    colProduct: "Product",
    productFeatures: "Features",
    productIntegrations: "Integrations",
    productHow: "How it works",
    colClinics: "Clinics",
    clinicsCases: "Cases",
    clinicsRegister: "Create account",
    clinicsFaq: "FAQ",
    colCompany: "Company",
    companyAbout: "About us",
    companyBlog: "Blog",
    companyContacts: "Contacts",
    colLegal: "Legal",
    legalPrivacy: "Privacy policy",
    legalTerms: "Terms of service",
    legalSecurity: "Security",
    copyright: "© 2026 AI Bot. Built for medical clinics.",
    disclaimer: "AI does not replace a doctor",
  },

  tweaks: {
    title: "Tweaks",
    theme: "Theme",
    scheme: "Color scheme",
  },
};
